"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SigHelperMock__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [{
    internalType: "string",
    name: "name",
    type: "string"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "ECDSAInvalidSignature",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "length",
    type: "uint256"
  }],
  name: "ECDSAInvalidSignatureLength",
  type: "error"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "s",
    type: "bytes32"
  }],
  name: "ECDSAInvalidSignatureS",
  type: "error"
}, {
  inputs: [],
  name: "SignatureAlreadyCancelled",
  type: "error"
}, {
  inputs: [],
  name: "DOMAIN_SEPARATOR",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "name",
    type: "string"
  }, {
    internalType: "string",
    name: "version",
    type: "string"
  }],
  name: "__SigHelper_initInternal",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "hash",
    type: "bytes32"
  }],
  name: "cancelHashInternal",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "cancelled",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "nonces",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "hash",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "signer",
    type: "address"
  }, {
    components: [{
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }],
    internalType: "struct SigHelper.Sig",
    name: "sig",
    type: "tuple"
  }],
  name: "validateSigInternal",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode = "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";
const isSuperArgs = xs => xs.length > 1;
class SigHelperMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(name, overrides) {
    return super.getDeployTransaction(name, overrides || {});
  }
  deploy(name, overrides) {
    return super.deploy(name, overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.SigHelperMock__factory = SigHelperMock__factory;
_defineProperty(SigHelperMock__factory, "bytecode", _bytecode);
_defineProperty(SigHelperMock__factory, "abi", _abi);